import { AvatarConfigType } from './../../types';
import logger from 'src/logger';
import { makeVideoRenderer, videoButtonType, videoRendererType } from 'src/sdk-components';
import { avatarComponentType } from 'src/sdk-components/avatar';
import { VSInteractionType } from 'src/sdk-components/VSObject';
import { LoadingState, TSceneNode } from 'src/service/scene/types';
import { MpSdk } from 'src/types';
import Scene from '../../scene';
import { NodeEventsTypes } from '../../enums';

class SceneAvatar extends Scene {
  readonly mpSDK: any;

  readonly assets: any = new Map<string, any[]>();

  constructor(mpSDK: MpSdk) {
    super(mpSDK);
    this.mpSDK = mpSDK;
  }

  async init() {
    await this.mpSDK.Scene.register(videoRendererType, makeVideoRenderer);
  }

  async create(data: any, options: AvatarConfigType): Promise<TSceneNode | undefined> {
    try {
      // adding avatar to the scene node
      const modelNode = await this.scene.createNode();
      const component = modelNode.addComponent(avatarComponentType, {
        label: data.name,
        url: data.url,
        uuid: data.uuid,
        visible: data.visible,
      });
      modelNode.obj3D.position.set(data.positionX, data.positionY, data.positionZ);
      modelNode.obj3D.rotation.set(data.rotationX, data.rotationY, data.rotationZ);
      modelNode.obj3D.quaternion.set(
        data.quaternionX,
        data.quaternionY,
        data.quaternionZ,
        data.quaternionW,
      );
      modelNode.obj3D.scale.set(0.75, 0.75, 0.75);
      const btnSize = 0.03;

      let muteBtnComponent;
      if (options.host && options.withButton) {
        const { mute, unMute } = options.withButton;
        muteBtnComponent = modelNode.addComponent(videoButtonType, {
          size: btnSize,
          src: mute,
          src2: unMute,
          localPosition: {
            x: 0.2,
            y: 0.23,
            z: 0.005,
          },
          localRotation: {
            x: 0,
            y: Math.PI,
            z: 0,
          },
        });
        if (muteBtnComponent.button) {
          muteBtnComponent.button.visible = false;
        }

        muteBtnComponent.onEvent = (type, eventData) => {
          if (type === VSInteractionType.HOVER) {
            this.emit(NodeEventsTypes.AVATAR_BUTTON_HOVER, {
              data,
              eventData,
            });
          }

          if (type === VSInteractionType.CLICK) {
            this.emit(NodeEventsTypes.AVATAR_BUTTON_CLICK, {
              data,
              eventData,
            });
          }
        };
      }

      modelNode.start();

      if (muteBtnComponent) {
        const objectRootProxy = component.outputs;
        objectRootProxy.onPropertyChanged('loadingState', (state: LoadingState) => {
          if (state === LoadingState.Loaded) {
            const labelSize = component.getLabelSize();
            muteBtnComponent.inputs.localPosition = {
              x: labelSize[0] * 0.5 + 0.05,
              y: 0.23,
              z: 0.005,
            };
          }
        });
      }

      return [modelNode, component];
    } catch (error) {
      logger.error(`Failed to init avatar:`, error);
    }
    return undefined;
  }
}

export default SceneAvatar;
